import { get } from 'lodash';
import { getErrors } from '../util';
import * as CONSTANTS from '../../constants';

const initialState = {
  isLoading: false,
  error: null,
  authProvidersList: {
    data: [],
    error: null,
    isLoading: false,
  },
  authProviderData: {
    data: null,
    error: null,
    isLoading: false,
  },
  createAuthProviderData: {
    data: {},
    error: null,
    isLoading: false,
  },
  updateAuthProviderData: {
    data: {},
    error: null,
    isLoading: false,
  },
  deleteAuthProviderData: {
    data: {},
    error: null,
    isLoading: false,
  },

  clientDefinitionsList: {
    data: [],
    error: null,
    isLoading: false,
  },
  createClientDefinitionData: {
    data: {},
    error: null,
    isLoading: false,
  },
  updateClientDefinitionData: {
    data: {},
    error: null,
    isLoading: false,
  },
  deleteClientDefinitionData: {
    data: {},
    error: null,
    isLoading: false,
  },
  wellKnownResponseData: {
    data: {},
    error: null,
    isLoading: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.RESET_AUTH_PROVIDERS_EDIT_STATUSES:
      return {
        ...state,
        ...initialState,
      };
    case CONSTANTS.FETCH_AUTH_PROVIDERS_LIST_REQUEST:
      return {
        ...state,
        authProvidersList: {
          data: [],
          error: null,
          isLoading: true,
        },
      };
    case CONSTANTS.FETCH_AUTH_PROVIDERS_LIST_SUCCESS:
      return {
        ...state,
        authProvidersList: {
          data: action.payload,
          error: null,
          isLoading: false,
        },
      };
    case CONSTANTS.FETCH_AUTH_PROVIDERS_LIST_ERROR:{
      const errors = getErrors(action.payload);
      return {
        ...state,
        authProvidersList: {
          data: [],
          error: errors.join(''),
          isLoading: false,
        },
      };
    }
    case CONSTANTS.FETCH_AUTH_PROVIDER_REQUEST:
      return {
        ...state,
        authProviderData: {
          data: null,
          error: null,
          isLoading: true,
        },
      };
    case CONSTANTS.FETCH_AUTH_PROVIDER_SUCCESS:
      return {
        ...state,
        authProviderData: {
          data: action.payload,
          error: null,
          isLoading: false,
        },
      };
    case CONSTANTS.FETCH_AUTH_PROVIDER_ERROR: {
      const errors = getErrors(action.payload);
      return {
        ...state,
        authProviderData: {
          data: null,
          error: errors.join(''),
          isLoading: false,
        },
      };
    }
    case CONSTANTS.UPDATE_AUTH_PROVIDER_REQUEST:
      return {
        ...state,
        updateAuthProviderData: {
          data: {},
          error: null,
          isLoading: true,
          status: '',
        },
      };
    case CONSTANTS.UPDATE_AUTH_PROVIDER_SUCCESS:
      return {
        ...state,
        updateAuthProviderData: {
          data: action.payload,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };
    case CONSTANTS.UPDATE_AUTH_PROVIDER_ERROR: {
      return {
        ...state,
        updateAuthProviderData: {
          data: {},
          error: action.payload,
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      };
    }
    case CONSTANTS.CREATE_AUTH_PROVIDER_REQUEST:
      return {
        ...state,
        createAuthProviderData: {
          data: null,
          error: null,
          isLoading: true,
          status: '',
        },
      };
    case CONSTANTS.CREATE_AUTH_PROVIDER_SUCCESS:
      return {
        ...state,
        createAuthProviderData: {
          data: action.payload,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };
    case CONSTANTS.CREATE_AUTH_PROVIDER_ERROR: {
      return {
        ...state,
        createAuthProviderData: {
          data: {},
          error: action.payload,
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      };
    }
    case CONSTANTS.DELETE_AUTH_PROVIDER_REQUEST:
      return {
        ...state,
        deleteAuthProviderData: {
          data: '',
          error: null,
          isLoading: true,
          status: '',
        },
      };
    case CONSTANTS.DELETE_AUTH_PROVIDER_SUCCESS:
      return {
        ...state,
        deleteAuthProviderData: {
          data: CONSTANTS.SUCCESS,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };
    case CONSTANTS.DELETE_AUTH_PROVIDER_ERROR: {
      const errors = getErrors(action.payload);
      return {
        ...state,
        deleteAuthProviderData: {
          data: CONSTANTS.FAIL,
          error: errors.join(''),
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      };
    }
    case CONSTANTS.FETCH_ALL_SAMPLE_CLIENT_METADATA_REQUEST:
      return {
        ...state,
        clientDefinitionsList: {
          data: [],
          error: null,
          isLoading: true,
        },
      };
    case CONSTANTS.FETCH_ALL_SAMPLE_CLIENT_METADATA_SUCCESS:
      return {
        ...state,
        clientDefinitionsList: {
          data: action.payload,
          error: null,
          isLoading: false,
        },
      };
    case CONSTANTS.FETCH_ALL_SAMPLE_CLIENT_METADATA_ERROR: {
      const errors = getErrors(action.payload);
      return {
        ...state,
        clientDefinitionsList: {
          ...state.clientDefinitionsList,
          error: errors.join(''),
          isLoading: false,
        },
      };
    }
    case CONSTANTS.UPDATE_SAMPLE_CLIENT_METADATA_REQUEST:
      return {
        ...state,
        updateClientDefinitionData: {
          ...state.updateClientDefinitionData,
          error: null,
          isLoading: true,
          status: '',
        },
      };

    case CONSTANTS.UPDATE_SAMPLE_CLIENT_METADATA_SUCCESS:
      return {
        ...state,
        updateClientDefinitionData: {
          data: action.payload,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };

    case CONSTANTS.UPDATE_SAMPLE_CLIENT_METADATA_ERROR: {
      return {
        ...state,
        updateClientDefinitionData: {
          ...state.updateClientDefinitionData,
          error: action.payload,
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      };
    }

    case CONSTANTS.CREATE_SAMPLE_CLIENT_METADATA_REQUEST:
      return {
        ...state,
        createClientDefinitionData: {
          data: null,
          error: null,
          isLoading: true,
          status: '',
        },
      };

    case CONSTANTS.CREATE_SAMPLE_CLIENT_METADATA_SUCCESS:
      return {
        ...state,
        createClientDefinitionData: {
          data: action.payload,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };

    case CONSTANTS.CREATE_SAMPLE_CLIENT_METADATA_ERROR: {
      return {
        ...state,
        createClientDefinitionData: {
          ...state.createClientDefinitionData,
          error: action.payload,
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      };
    }

    case CONSTANTS.DELETE_SAMPLE_CLIENT_METADATA_REQUEST:
      return {
        ...state,
        deleteClientDefinitionData: {
          data: '',
          error: null,
          isLoading: true,
          status: '',
        },
      };

    case CONSTANTS.DELETE_SAMPLE_CLIENT_METADATA_SUCCESS:
      return {
        ...state,
        deleteClientDefinitionData: {
          data: CONSTANTS.SUCCESS,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };

    case CONSTANTS.DELETE_SAMPLE_CLIENT_METADATA_ERROR: {
      return {
        ...state,
        deleteClientDefinitionData: {
          data: CONSTANTS.FAIL,
          error: action.payload,
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      }
    }

    case CONSTANTS.FETCH_AUTH_PROVIDER_WELLKNOWN_REQUEST:
      return {
        ...state,
        wellKnownResponseData: {
          data: null,
          error: null,
          isLoading: true,
          status: null,
        },
      };

    case CONSTANTS.FETCH_AUTH_PROVIDER_WELLKNOWN_SUCCESS:
      return {
        ...state,
        wellKnownResponseData: {
          data: action.payload,
          error: null,
          isLoading: false,
          status: CONSTANTS.SUCCESS,
        },
      };

    case CONSTANTS.FETCH_AUTH_PROVIDER_WELLKNOWN_ERROR: {
      const errors = getErrors(action.payload);
      return {
        ...state,
        wellKnownResponseData: {
          data: null,
          error: errors.join(''),
          isLoading: false,
          status: CONSTANTS.FAIL,
        },
      }
    }

    case CONSTANTS.CLEAR_CLIENT_METADATA_STATUSES:
      return {
        ...state,
        deleteClientDefinitionData: {
          ...initialState.deleteClientDefinitionData,
        },
        createClientDefinitionData: {
          ...initialState.createClientDefinitionData,
        },
        updateClientDefinitionData: {
          ...initialState.updateClientDefinitionData,
        },
        wellKnownResponseData: {
          ...initialState.wellKnownResponseData,
        },
      };

    case CONSTANTS.RESET_AUTH_PROVIDERS_LIST_STATUS:
      return {
        ...state,
        authProvidersList: {
          data: [],
          error: null,
          isLoading: false,
        },
      };
    default:
      return state;
  }
}

export const getAuthProvidersList = (state) => get(state, 'authProviders.authProvidersList.data');
export const getIsAuthProvidersListLoading = (state) => get(state, 'authProviders.authProvidersList.isLoading');
export const getAuthProvidersListError = (state) => get(state, 'authProviders.authProvidersList.error');

export const getAuthProvider = (state) => get(state, 'authProviders.authProviderData.data');
export const getIsAuthProviderLoading = (state) => get(state, 'authProviders.authProviderData.isLoading');
export const getAuthProviderError = (state) => get(state, 'authProviders.authProviderData.error');

export const getCreateAuthProviderError = (state) => get(state, 'authProviders.createAuthProviderData.error');
export const getCreateAuthProviderStatus = (state) => get(state, 'authProviders.createAuthProviderData.status');
export const isCreatingAuthProvider = (state) => get(state, 'authProviders.createAuthProviderData.isLoading');
export const getCreatedAuthProvider = (state) => get(state, 'authProviders.createAuthProviderData.data');

export const getUpdateAuthProviderError = (state) => get(state, 'authProviders.updateAuthProviderData.error');
export const getUpdateAuthProviderStatus = (state) => get(state, 'authProviders.updateAuthProviderData.status');
export const isUpdatingAuthProvider = (state) => get(state, 'authProviders.updateAuthProviderData.isLoading');

export const getDeleteAuthProviderError = (state) => get(state, 'authProviders.deleteAuthProviderData.error');
export const getDeleteAuthProviderStatus = (state) => get(state, 'authProviders.deleteAuthProviderData.status');
export const isDeletingAuthProvider = (state) => get(state, 'authProviders.deleteAuthProviderData.isLoading');

export const getClientDefintionsList = (state) => get(state, 'authProviders.clientDefinitionsList.data');
export const getListClientDefintionsInProgress = (state) => get(state, 'authProviders.clientDefinitionsList.isLoading');
export const getClientDefintionsListError = (state) => get(state, 'authProviders.clientDefinitionsList.error');

export const getCreateClientDefinitionError = (state) => get(state, 'authProviders.createClientDefinitionData.error');
export const getCreateClientDefinitionStatus = (state) => get(state, 'authProviders.createClientDefinitionData.status');
export const getIsCreateClientDefinitionInProgress = (state) => get(state, 'authProviders.createClientDefinitionData.isLoading');

export const getUpdateClientDefinitionError = (state) => get(state, 'authProviders.updateClientDefinitionData.error');
export const getUpdateClientDefinitionStatus = (state) => get(state, 'authProviders.updateClientDefinitionData.status');
export const getIsUpdatingClientDefinition = (state) => get(state, 'authProviders.updateClientDefinitionData.isLoading');

export const getDeleteClientDefinitionError = (state) => get(state, 'authProviders.deleteClientDefinitionData.error');
export const getDeleteClientDefinitionStatus = (state) => get(state, 'authProviders.deleteClientDefinitionData.status');
export const getIsDeleteClientDefinitionInProgress = (state) => get(state, 'authProviders.deleteClientDefinitionData.isLoading');

export const getWellKnownResponseError = (state) => get(state, 'authProviders.wellKnownResponseData.error');
export const getWellKnownResponseStatus = (state) => get(state, 'authProviders.wellKnownResponseData.status');
export const getWellKnownResponseInProgress = (state) => get(state, 'authProviders.wellKnownResponseData.isLoading');
export const getWellKnownResponseData = (state) => get(state, 'authProviders.wellKnownResponseData.data');
